import initialState from './initialState'
import {FETCH_STATS, RECEIVE_STATS} from '../actions/actionTypes'

export default function stats(state = initialState.stats, action) {
	let newState
	switch (action.type) {
	case FETCH_STATS:
		return {
			...action,
			isFetching: true
		}
	case RECEIVE_STATS:
		newState = action.stats
		return {
			...newState,
			isFetching: false
		}
	default:
		return state
	}
}


// WEBPACK FOOTER //
// ./src/redux/reducers/stats.js